import { html } from "lit-element";
import { DrawSVGBaseModule } from "../../ModuleBase/svg-base-module";

export class DrawSluisVer2Module extends DrawSVGBaseModule {
	constructor(canvas) {
		super(canvas);

		this.name = "sluis-ver-2";
		this.icon = svg_sluis_ver_2;
	}
}

window.customElements.define("inspx-draw-sluis-ver-2-module", DrawSluisVer2Module);

const svg_sluis_ver_2 = html`
<svg width="45" height="90" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg">
<g>
 <title>Layer 1</title>
 <rect fill="#ffffff" x="0" y="0" width="44.9502" height="90" id="svg_1" stroke="#444444"/>
 <line fill="none" x1="0" y1="30" x2="44.41626" y2="30" id="svg_2" stroke="#444444"/>
 <line fill="none" x1="0" y1="60" x2="44.59424" y2="60" id="svg_3" stroke="#444444"/>
 <rect fill="#aaa7a7" stroke-dasharray="null" stroke-linejoin="null" stroke-linecap="null" x="0.15269" y="0.31296" width="44.36392" height="29.28303" id="svg_5" stroke-width="0" stroke="#000000"/>
 <text stroke="#000000" transform="matrix(0.6447996209498831,0,0,0.9600566543589287,-4.642872621085231,-7.394998887705053) " xml:space="preserve" text-anchor="middle" font-family="Sans-serif" font-size="24" id="svg_6" y="63.2331" x="41.69337" stroke-linecap="null" stroke-linejoin="null" stroke-dasharray="null" stroke-width="0" fill="#000000">sluis</text>
</g>
</svg>
`;
